import store from '../../store'
import { ChatService, CampaignsService, ShopsService } from '../services'
import { chatUtils } from '../utils'

const isEcommercePlatform = store.getters.isEcommercePlatform
const productType = isEcommercePlatform ? 'shop': 'camp' 

export const getRooms = (onRoomsChange) => {
    const userId = store.state.user.uid
    const detachRoomsListener = ChatService.getRoomsByUserId(userId).onSnapshot(
        (snapshot) => {
            const rooms = snapshot.docs.map(
                (doc) => {
                    const room = {
                        ...doc.data(),
                        id: doc.id
                    }
                    
                    const productId = Object.keys(room).find(key => key.startsWith(`${productType}-`) &&
                        room[key].uid !== userId);

                    if (room[productId]) {
                        room.name = room[productId].name
                        room.pic = room[productId].pic
                        room.myPic = room[productId].nextPic
                    }

                    return room
                }
            ).filter(
                (room) => room.name
            )
            return onRoomsChange(rooms)
        },
        (err) => {
            console.log(err, 'error getting rooms')
        }
    )

    return detachRoomsListener
}

export const getRoom = (roomId) => {
    const userId = store.state.user.uid

    return ChatService.getRoomById(roomId).get().then(
        (doc) => {
            const room = {
                ...doc.data(),
                id: doc.id,
            }
            const productId = Object.keys(room).find(
                (key) => (
                    key.startsWith(`${productType}-`) &&
                    room[key].uid !== userId
                )
            )

            if (room[productId]) {
                room.contact_name = room[productId].name
                room.contact_camp_id = room[productId].id
                room.contact_pic = room[productId].pic
                room.partnerId = room[productId].uid
            }

            return room
        }
    ).catch(
        (e) => console.log(e, 'error loading room')
    )
}

export const createRoom = (campaignIds) => (
    Promise.all([
        CampaignsService.getCampaignById(campaignIds[0]).get(),
        CampaignsService.getCampaignById(campaignIds[1]).get(),
    ])
    .then(
        (campaignSnapshots) => {
            const invalidData = campaignSnapshots.find(
                (campaign) => !campaign.exists
            )

            if (invalidData) {
                throw new Error('invalid campaign data')
            }

            const campaigns = campaignSnapshots.map(
                (doc) => ({
                    ...doc.data(),
                    id: doc.id,
                })
            )

            return ChatService.createRoom(
                chatUtils.emptyRoom(campaigns)
            )
        }
    )
    .catch(
        (e) => console.log(e, 'error creating room')
    )
)
export const createShopRoom = (shopsIds) => (
    Promise.all([
        ShopsService.getRef(shopsIds[0]).get(),
        ShopsService.getRef(shopsIds[1]).get()
    ])
    .then(
        (shopSnapshots) => {
            const invalidData = shopSnapshots.find(
                (shop) => !shop.exists
            )
            if (invalidData) {
                throw new Error('invalid campaign data')
            }
            
            const shops = shopSnapshots.map(
                (doc) => ({
                    ...doc.data(),
                    id: doc.id,
                })
            )

            return ChatService.createRoom(
                chatUtils.emptyShopRoom(shops, shopsIds)
            )
        }
    )
    .catch(
        (e) => console.log(e, 'error creating room')
    )
)

export const markRoomAsSeen = (room) => {

    const userId = store.state.user.uid

    if (!room.lastMessage ||
        !room.lastMessage.message ||
        room.lastMessage.seen ||
        room.lastMessage.uid === userId) {
        return
    }

    ChatService.markRoomAsSeen(room.id)
    if(store.state.unreadMessages){
        const unreadMessages = store.state.unreadMessages
        for(let item in unreadMessages){
            if(unreadMessages[item].chatroom === room.id){
                ChatService.markNotificationsAsRead(userId, item)
            }
        }
        
    }
}

export const markAllMessagesAsRead = () => {
    ChatService.markAllMessagesAsRead(store.state.user.uid)
}

export const getMessages = (roomId, onMessage) => {
    const snapshot = ChatService.getMessages(roomId)

    snapshot.on(
        'child_added',
        (doc) => onMessage({
            ...doc.val(),
            id: doc.key
        })
    )

    const detachMessagesListener = () => {
        snapshot.off('child_added')
    }

    return detachMessagesListener
}

export const sendMessage = ({
    roomId,
    message,
    partnerId,
}) => {
    const userId = store.state.user.uid
    const username = store.state.user.name

    ChatService.saveMessage({ roomId, userId, username, message })
    ChatService.updateRoomLastMessage({ roomId, userId, message })
    ChatService.notifyPartner({ roomId, partnerId })
}